import React from "react";

interface ButtonProps {
  text: string;
  type: "button" | "submit" | "reset";
  isMobile?: boolean;
  onClick?: () => void;
  className?: string;
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
  disabled?: boolean; // Added disabled prop
}

const Button: React.FC<ButtonProps> = ({
  text,
  type,
  onClick,
  className = "",
  bgColor = "bg-blue-500",
  textColor = "text-white",
  hoverBgColor = "bg-blue-600",
  disabled = false, // Default to false
}) => {
  return (
    <button
      type={type}
      className={`${className} w-full py-2 font-semibold ${textColor} ${bgColor} rounded-3xl hover:${hoverBgColor} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      onClick={type !== "submit" ? onClick : undefined}
      disabled={disabled} // Pass disabled to the HTML button
    >
      {text}
    </button>
  );
};

export default Button;